import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock } from "vue"




export default /*@__PURE__*/_defineComponent({
  __name: 'setupDeviceChecklist',
  props: {
  isTurnOnHeadphonesChecked: {
    type: Boolean,
    required: true,
  },
  isDonglePluggedInChecked: {
    type: Boolean,
    required: true,
  },
  isConnectHeadphonesViaBluetoothChecked: {
    type: Boolean,
    required: true,
  },
  setIsTurnOnHeadphonesChecked: {
    type: Function,
    required: true,
  },
  setIsDonglePluggedInChecked: {
    type: Function,
    required: true,
  },
  setIsConnectHeadphonesViaBluetoothChecked: {
    type: Function,
    required: true,
  },
},
  setup(__props) {

const props = __props;

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_VCheckbox = _resolveComponent("VCheckbox")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    style: {"width":"350px","flex-grow":"0","background":"white","border-radius":"8px"},
    class: "w-60 px-4 py-4 mb-10 rounded-xl border-sm text-start"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, { style: {"text-align":"center"} }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode("Checklist")
        ])),
        _: 1
      }),
      _createVNode(_component_VCheckbox, {
        "model-value": props.isTurnOnHeadphonesChecked,
        "onUpdate:modelValue": props.setIsTurnOnHeadphonesChecked,
        label: "Turn on Headphones",
        "hide-details": "",
        style: _normalizeStyle({
        color: props.isTurnOnHeadphonesChecked ? '#939393' : 'inherit',
      })
      }, null, 8, ["model-value", "onUpdate:modelValue", "style"]),
      _createVNode(_component_v_divider),
      _createVNode(_component_VCheckbox, {
        "model-value": props.isDonglePluggedInChecked,
        "onUpdate:modelValue": props.setIsDonglePluggedInChecked,
        label: "Plug in USB-Dongle",
        "hide-details": "",
        style: _normalizeStyle({
        color: props.isDonglePluggedInChecked ? '#939393' : 'inherit',
      })
      }, null, 8, ["model-value", "onUpdate:modelValue", "style"]),
      _createVNode(_component_v_divider),
      _createVNode(_component_VCheckbox, {
        "model-value": props.isConnectHeadphonesViaBluetoothChecked,
        "onUpdate:modelValue": props.setIsConnectHeadphonesViaBluetoothChecked,
        label: "Connect Headphones via Bluetooth to your Computer",
        "hide-details": "",
        style: _normalizeStyle({
        color: props.isConnectHeadphonesViaBluetoothChecked
          ? '#939393'
          : 'inherit',
      })
      }, null, 8, ["model-value", "onUpdate:modelValue", "style"])
    ]),
    _: 1
  }))
}
}

})